export class ResponseError {
    Key: string;
    Value: Array<string>
}


// WEBPACK FOOTER //
// ./app/objects/common/responseError.ts